module.exports = function getResource (label, vars = []) {
    let resources = {
        checkoutButton: 'Checkout',
        continueToCheckoutButton: 'Continue to Checkout',
        checkoutPickupItems: 'Checkout Pickup Items',
        checkoutShippedItems: 'Checkout Shipped Items'
    };
    return resources[label];
};
